export default __webpack_public_path__ + "static/media/07.1c203126.png";